import React, { useEffect } from 'react';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import FilterButton from '../../FilterButton/FilterButton';
import useFilterState from '../../../hooks/useFilterState';
import useFilterItemsWithAmount from '../../../hooks/useFilterItemsWithAmount';
import { filtersData } from '../../../constants/filtersData';
import { filterNames } from '../../../constants/filterNames';
import FilterContainer from '../../FilterContainer/FilterContainer';
import SelectedOption from '../../SelectedOption/SelectedOption';
import useRequestPriorities from '../../../../../queries/useRequestPriorities';
import { useFilterOptionsShorter } from '../../../hooks/useFilterOptionsShorter';
import { HiddenSelectedOptions } from '../../HiddenSelectedOptions/HiddenSelectedOptions';

const filter = filtersData[filterNames.priorities];

const createPriorityText = (item) =>
  [item.code, item.name].filter(Boolean).join(' - ');

const PrioritiesFilter = ({ disabled = false }) => {
  const [filterState, setFilterState] = useFilterState(filter);

  const { data } = useRequestPriorities({ staleTime: Infinity });

  const { items, itemsMap } = useFilterItemsWithAmount({
    data,
    requestKey: 'priority.id',
    notIndicated: { id: 0, name: 'Не указано', amount: 0 },
  });

  const handleItemRemove = (id) => {
    const newState = filterState.filter((itemId) => itemId !== id);

    setFilterState(newState);
  };

  const hasFilter = filterState.length > 0;
  const allSelected = hasFilter && itemsMap.size === filterState.length;

  useEffect(() => {
    if (filterState.length && items.length) {
      const newFilter = filterState.filter((filterId) =>
        items.some((item) => item.id === filterId)
      );

      setFilterState(newFilter);
    }
  }, [items, filterState]);

  const filteredItems = items.filter((item) => filterState.includes(item.id));
  const { visibleItems, hiddenItems } = useFilterOptionsShorter(filteredItems);

  return (
    <FilterContainer>
      <FilterDropdown
        disabled={disabled}
        filter={filter}
        items={items}
        getItemContent={createPriorityText}
        getSearchContent={createPriorityText}
        renderButton={({ visible }) => (
          <FilterButton
            text="Приоритет"
            opened={visible}
            selected={hasFilter}
          />
        )}
      />
      {allSelected ? (
        <SelectedOption
          text="Все"
          onRemove={() => setFilterState([])}
        />
      ) : (
        <>
          {visibleItems.map((item) => (
            <SelectedOption
              key={item.id}
              text={createPriorityText(item)}
              value={item.id}
              onRemove={handleItemRemove}
            />
          ))}
          {Array.isArray(hiddenItems) && !!hiddenItems.length && (
            <HiddenSelectedOptions
              hiddenItems={hiddenItems}
              handleItemRemove={handleItemRemove}
            />
          )}
        </>
      )}
    </FilterContainer>
  );
};

export default PrioritiesFilter;
